import loadable from '@loadable/component';

// 懒加载组件
const SupplierLicense = loadable(() => import('./supplierLicense/SupplierLicense'));
const AddLicenses = loadable(() => import('./supplierLicense/addLicenses/AddLicenses'));
const LicenseQuery = loadable(() => import('./licenseQuery/LicenseQuery'));
const DocuementLicenseManagement = loadable(() => import('./licenseQuery/documentLicenseManagement/DocuementLicenseManagement'));
const LicenseDetail = loadable(() => import('./licenseDetail/LicenseDetail'));

export const subRoutes = [
  {
    path: '/SupplierLicense',
    component: SupplierLicense
  },
  {
    path: '/AddLicenses',
    component: AddLicenses
  },
  {
    path: '/LicenseQuery',
    component: LicenseQuery
  },
  {
    path: '/DocuementLicenseManagement',
    component: DocuementLicenseManagement
  },
  {
    path: '/LicenseDetail',
    component: LicenseDetail
  }
];
